
import React from 'react';

const CompanyInfoSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-4xl font-bold text-center mb-16 text-gray-800">
            会社概要
          </h2>
          <div className="bg-gray-50 rounded-lg p-8">
            <table className="w-full">
              <tbody className="space-y-4">
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100 w-1/3">
                    会社名
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    株式会社PM不動産
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    所在地
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    〒150-0001 東京都渋谷区神宮前1-1-1
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    電話番号
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    03-1234-5678
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    設立
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    2005年4月
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    資本金
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    1,000万円
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    代表者
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    代表取締役　田中 太郎
                  </td>
                </tr>
                <tr className="border-b border-gray-200">
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    事業内容
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    不動産売買・賃貸仲介・管理・リフォーム・相続相談
                  </td>
                </tr>
                <tr>
                  <td className="py-4 px-6 font-semibold text-gray-800 bg-gray-100">
                    免許番号
                  </td>
                  <td className="py-4 px-6 text-gray-700">
                    宅地建物取引業 東京都知事（3）第00000号
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CompanyInfoSection;
